import * as React from "react";

function AmericanAxelManufacturingIcon(props) {
  const { className, height, width } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 68 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        data-name="Path 7031"
        d="m 23.11,20.035 a 3.19,3.19 0 0 1 -2.354,-2.2 L 15.495,3.909 h -1.65 L 8.876,17.417 A 3.549,3.549 0 0 1 6.06,20.035 v 1.056 h 6.16 v -1.012 c -0.946,-0.264 -1.848,-0.638 -1.848,-1.694 a 2.908,2.908 0 0 1 0.2,-0.946 l 0.814,-2.288 h 5.082 l 0.968,2.618 a 2.169,2.169 0 0 1 0.154,0.77 c 0,0.968 -0.9,1.3 -1.76,1.518 v 1.034 h 7.282 z m -11.176,-6.314 2,-5.28 1.98,5.28 z m 28.226,6.314 a 3.19,3.19 0 0 1 -2.354,-2.2 L 32.548,3.909 h -1.653 l -4.969,13.508 a 3.549,3.549 0 0 1 -2.816,2.618 v 1.056 h 6.16 v -1.012 c -0.946,-0.264 -1.848,-0.638 -1.848,-1.694 a 2.908,2.908 0 0 1 0.2,-0.946 l 0.814,-2.288 h 5.08 l 0.968,2.618 a 2.169,2.169 0 0 1 0.154,0.77 c 0,0.968 -0.9,1.3 -1.76,1.518 v 1.034 h 7.282 z m -11.176,-6.314 2,-5.28 1.98,5.28 z M 61.94,3.931 h -6.292 l -4,11.242 -3.832,-11.242 h -6.732 v 1.034 c 0.836,0.154 2.332,0.9 2.332,2.222 v 11.044 c 0,1.276 -1.276,1.606 -2.156,1.826 v 1.034 h 6.072 v -1.012 c -0.858,-0.154 -2,-0.682 -2,-1.8 V 6.439 l 4.992,14.652 h 1.21 L 56.595,6.725 v 11.638 c 0,1.254 -1.012,1.43 -2,1.672 v 1.056 h 7.1 v -1.012 c -0.726,-0.154 -2,-0.418 -2,-1.65 V 6.991 c 0,-1.452 1.276,-1.76 2.244,-2.024 z"
        fill="#db0404"
        clipPath="none"
      />
    </svg>
  );
}

export default AmericanAxelManufacturingIcon;
